// =====================================================================
// spellcheckService (S118) — chama o corretor do backend (proxy pro
// LanguageTool self-hosted). isAuth; escopo = company do JWT.
// Retorna { enabled, matches:[{offset,length,message,replacements,issueType,ruleId}] }.
// =====================================================================
import api from "./api";

export const checkSpelling = async (text, language = "pt-BR") =>
  (await api.post("/spellcheck", { text, language })).data;
